import api from "./axios";
import { apiPaths } from "./paths";
import type { MatchProperty, ApiMessage } from "@/types";

export const getMatchProperties = () =>
  api.get<MatchProperty[]>(apiPaths.matchProperties.list).then((r) => r.data);

export const getMatchProperty = (id: string) =>
  api.get<MatchProperty>(apiPaths.matchProperties.one(id)).then((r) => r.data);

export const createMatchProperty = (data: Partial<MatchProperty>) =>
  api
    .post<MatchProperty>(apiPaths.matchProperties.list, data)
    .then((r) => r.data);

export const updateMatchProperty = (id: string, data: Partial<MatchProperty>) =>
  api
    .patch<MatchProperty>(apiPaths.matchProperties.one(id), data)
    .then((r) => r.data);

export const deleteMatchProperty = (id: string) =>
  api.delete<ApiMessage>(apiPaths.matchProperties.one(id)).then((r) => r.data);
